import {maxBy} from 'lodash';
import moment from 'moment';

export function sortChatSessionsByLastMessage(s) {
    const lastMessage = maxBy(s.messages, s => moment(s.postedOn ?? 0).valueOf());
    return moment(lastMessage.postedOn).valueOf() * -1;
}
